import Button from '@zenbusiness/zui/Button';
import CircularProgress from '@zenbusiness/zui/CircularProgress';
import Dialog from '@zenbusiness/zui/Dialog';
import DialogActions from '@zenbusiness/zui/DialogActions';
import DialogContent from '@zenbusiness/zui/DialogContent';
import DialogTitle from '@zenbusiness/zui/DialogTitle';
import IconButton from '@zenbusiness/zui/IconButton';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { useTheme } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';
import PropTypes from 'prop-types';

const CustomButton = ({ onClick, text = '', src, positionIcon }) => {
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  return isMobile ? (
    <IconButton
      label=""
      onClick={onClick}
      size="medium"
    >
      <Stack
        alignItems="center"
        height={32}
        justifyContent="center"
        width={32}
      >
        <SharedAsset
          alt={text}
          height={13}
          src={src}
          width={13}
        />
      </Stack>
    </IconButton>
  ) : (
    <Button
      endIcon={
        positionIcon === 'end' && (
          <SharedAsset
            alt={text}
            height={16}
            src={src}
            width={16}
          />
        )
      }
      icon={
        positionIcon === 'start' && (
          <SharedAsset
            alt={text}
            height={16}
            src={src}
            width={16}
          />
        )
      }
      onClick={onClick}
      size="medium"
      variant="text"
    >
      {text}
    </Button>
  );
};
CustomButton.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  src: PropTypes.string,
  positionIcon: PropTypes.oneOf(['start', 'end'])
};

export default function CustomizedDialog({ handleClose, children, title, buttonProps }) {
  const theme = useTheme();
  return (
    <Dialog
      disableRestoreFocus
      fullScreen
      onClose={handleClose}
      open
      PaperProps={{
        style: {
          backgroundColor: theme.palette.background.grey.main
        }
      }}
    >
      <DialogTitle
        alignItems="center"
        display="flex"
        justifyContent="space-between"
        pb={{ xs: 0 }}
        pt={{ xs: '4px', md: '12px' }}
        px={{ xs: '4px', md: '12px' }}
      >
        <CustomButton
          onClick={handleClose}
          positionIcon="start"
          src="/icon/micro/caret-left.svg"
          text="Back"
        />
        <Text
          color="primary"
          size="xl"
        >
          {title}
        </Text>
        <CustomButton
          onClick={handleClose}
          positionIcon="end"
          src="/icon/micro/close-x.svg"
          text="Close"
        />
      </DialogTitle>
      <DialogContent sx={{ mx: 'auto' }}>{children}</DialogContent>
      <DialogActions sx={{ maxWidth: 1440, mx: 'auto', width: '100%' }}>
        {buttonProps && (
          <Button
            disabled={buttonProps.disabled || buttonProps.loading}
            icon={buttonProps.loading && <CircularProgress size={16} />}
            onClick={buttonProps.onClick}
            size="large"
            variant={buttonProps.variant || 'contained'}
          >
            {buttonProps.text}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

CustomizedDialog.propTypes = {
  title: PropTypes.string,
  handleClose: PropTypes.func,
  children: PropTypes.node,
  buttonProps: PropTypes.shape({
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func,
    variant: PropTypes.string,
    text: PropTypes.string
  })
};
